import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-no-wrap justify-start fill-height pa-2 align-center" }
const _hoisted_2 = { class: "d-flex flex-column ml-2 flex-grow-1" }
const _hoisted_3 = { class: "text-subtitle-2 font-weight-bold text-center" }

import { computed, ref } from "vue";
import emblemGrenoble from "@/assets/grenobleImage";

import OffersList from "./OffersList.vue";
import type { Partner, Offer } from "@emblem/api";
import PlacesList from "./PlacesList.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerCard',
  props: {
    partner: null,
    offerFilter: null,
    offersInDialog: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  partner: Partner;
  offerFilter?: (offer: Offer) => boolean;
  offersInDialog?: boolean;
}



const offers = computed(() =>
  props.offerFilter
    ? props.partner.offers.filter(props.offerFilter)
    : props.partner.offers
);

const showPlaces = ref(false);

const displayPlaces = () => (showPlaces.value = true);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_img, {
          "lazy-src": _unref(emblemGrenoble),
          src: __props.partner.thumbnail,
          "min-width": "100",
          "max-width": "100"
        }, null, 8, ["lazy-src", "src"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.partner.name.toUpperCase()), 1),
          (!__props.offersInDialog)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                class: "pa-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(OffersList, { offers: _unref(offers) }, null, 8, ["offers"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_btn, {
          icon: "fas fa-circle-info",
          class: "info-btn",
          size: "small",
          variant: "plain",
          onClick: _withModifiers(displayPlaces, ["stop"])
        }, null, 8, ["onClick"]),
        (__props.offersInDialog)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              icon: "fas fa-shop",
              class: "offers-btn",
              size: "small",
              variant: "plain"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { icon: "fas fa-shop" }),
                (__props.offersInDialog)
                  ? (_openBlock(), _createBlock(_component_v_dialog, {
                      key: 0,
                      activator: "parent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(OffersList, { offers: _unref(offers) }, null, 8, ["offers"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (__props.partner.places.length)
        ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 0,
            modelValue: showPlaces.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showPlaces).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                width: "400px",
                "max-width": "90vw"
              }, {
                default: _withCtx(() => [
                  _createVNode(PlacesList, {
                    places: __props.partner.places
                  }, null, 8, ["places"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})